import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import Cover from "../components/cover";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Cover title="Escala de Grises" link="/grayscale" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="Cover">
  Escala de grises
    </Cover>
    <ProjectCard title="Repositorio" target="https://github.com/cv-2020-1/cv-2020-1.github.io" link="https://github.com/cv-2020-1/cv-2020-1.github.io" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  Primer post para dar la bienvenida a una serie de publicaciones para distintos
  proyectos, link del repositorio.
    </ProjectCard>
    <Cover title="Convolucion con P5" link="/convolutionMask" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="Cover">
  Convoluciones en P5 con distintos kernels para tratamiento de imágenes.
    </Cover>
    <Cover title="Histograma" link="/histograma" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="Cover">
  Histograma de imagen
    </Cover>
    <Cover title="Eficiencia computacional" link="/video" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="Cover">
  Eficiencia computacional con videos
    </Cover>
    <Cover title="Ilusiones Por Software" link="/ilusions" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="Cover">
  Ilusiones por Software
    </Cover>
    <ProjectCard title="Ilusiones Con Shaders" target="https://cv-2020-1.github.io/Shaders/pages/ilusionFragmentShader.html" link="https://cv-2020-1.github.io/Shaders/pages/ilusionFragmentShader.html" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  Nuestras ilusiones con Shaders
    </ProjectCard>
    <Cover title="Taller de iluminacion" link="/lights" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="Cover">
  Luz Ambiental, Difusa y Especular con Shaders
    </Cover>
    <Cover title="Movimiento Browniano" link="/brownian" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="Cover">
  Exposición Movimiento Browniano
    </Cover>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      